export default "__VITE_ASSET__CZpXK0Eg__"